import { Checkbox, Space } from 'antd';
import { DAYS_OF_WEEK } from '../util/dates';
import { CSSProperties, useEffect, useState } from 'react';
import { DayOfWeek } from '../util/types';
import * as _ from 'lodash';
import { CheckboxChangeEvent } from 'antd/es/checkbox';

// Only weekdays by default
// const DEFAULT_SELECTED_DAYS_OF_WEEK: DayOfWeek[] = DAYS_OF_WEEK.filter(d => d.isWeekday);
// All days by default
const DEFAULT_SELECTED_DAYS_OF_WEEK: DayOfWeek[] = DAYS_OF_WEEK;

interface DayOfWeekSelectorProps {
  disabled?: boolean;
  onChange?: (value: DayOfWeek[]) => void;
  value: DayOfWeek[];
  style?: CSSProperties;
}

const DayOfWeekSelector = (props: DayOfWeekSelectorProps) => {
  const [selectedDays, setSelectedDays] = useState<DayOfWeek[]>(props.value || DEFAULT_SELECTED_DAYS_OF_WEEK);
  const [allWeekdaysChecked, setAllWeekdaysChecked] = useState<boolean>(false);
  const [allWeekdaysIndeterminate, setAllWeekdaysIndeterminate] = useState<boolean>(false);
  const [allWeekendsChecked, setAllWeekendsChecked] = useState<boolean>(false);
  const [allWeekendsIndeterminate, setAllWeekendsIndeterminate] = useState<boolean>(false);

  useEffect(() => {
    const numWeekdaysSelected = selectedDays.filter(d => d.isWeekday).length;
    const numWeekendsSelected = selectedDays.filter(d => !d.isWeekday).length;

    setAllWeekdaysChecked(numWeekdaysSelected === 5);
    setAllWeekdaysIndeterminate(numWeekdaysSelected < 5 && numWeekdaysSelected > 0);

    setAllWeekendsChecked(numWeekendsSelected === 2);
    setAllWeekendsIndeterminate(numWeekendsSelected < 2 && numWeekendsSelected > 0);
  }, [selectedDays]);

  useEffect(() => {
    if (props.onChange) props.onChange(selectedDays);
  }, [selectedDays]);

  const checkAllWeekdays = (e: CheckboxChangeEvent) => {
    if (e.target.checked) {
      setSelectedDays(_.uniqBy([...selectedDays, ...DAYS_OF_WEEK.filter(d => d.isWeekday)], 'value'));
    } else setSelectedDays(selectedDays.filter(d => !d.isWeekday));
  };

  const checkAllWeekends = (e: CheckboxChangeEvent) => {
    if (e.target.checked) {
      setSelectedDays(_.uniq([...selectedDays, ...DAYS_OF_WEEK.filter(d => !d.isWeekday)]));
    } else setSelectedDays(selectedDays.filter(d => d.isWeekday));
  };

  return (
    <Space direction={'horizontal'} wrap={true} style={props.style}>
      <Space direction={'vertical'}>
        <Checkbox
          disabled={props.disabled}
          indeterminate={allWeekdaysIndeterminate}
          checked={allWeekdaysChecked}
          onChange={checkAllWeekdays}
        >All Weekdays</Checkbox>
        <Checkbox.Group
          disabled={props.disabled}
          options={DAYS_OF_WEEK.filter(d => d.isWeekday)}
          value={selectedDays.map(d => d.value)}
          // Remove all the weekdays, and add the selected ones back in
          onChange={selected => setSelectedDays(_.uniq([
            ...selectedDays.filter(d => !d.isWeekday),
            ...DAYS_OF_WEEK.filter(d => selected.includes(d.value)),
          ]))
          }
        />
      </Space>
      <Space direction={'vertical'}>
        <Checkbox
          disabled={props.disabled}
          indeterminate={allWeekendsIndeterminate}
          checked={allWeekendsChecked}
          onChange={checkAllWeekends}
        >All Weekends</Checkbox>
        <Checkbox.Group
          disabled={props.disabled}
          options={DAYS_OF_WEEK.filter(d => !d.isWeekday)
            .sort((a, b) => b.value - a.value)}
          value={selectedDays.map(d => d.value)}
          // Remove all the weekdays, and add the selected ones back in
          onChange={selected => setSelectedDays(_.uniq([
            ...selectedDays.filter(d => d.isWeekday),
            ...DAYS_OF_WEEK.filter(d => selected.includes(d.value)),
          ]))
          }
        />
      </Space>
    </Space>
  );
};

export default DayOfWeekSelector;
